import React from "react";
import "./PartnersSection.css";
import experiences from "../data/experiences.json";
import ExperienceCard from "./ExperienceCard";
import { iconMap as mapIcon, iconArrowDown as arrowDown } from "../data/assets";

export default function PartnersSection() {
  const scrollToMap = (e) => {
    e.preventDefault();
    const el = document.getElementById("beef-map");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="beef-partners beef-container">
      <div className="beef-partners__grid">
        {experiences.map((item) => (
          <ExperienceCard key={item.id} data={item} />
        ))}

        <div className="beef-map-cta">
          <div className="beef-map-cta__top">
            <img
              className="beef-map-cta__icon"
              src={mapIcon}
              alt=""
              aria-hidden="true"
            />
            <h3 className="beef-map-cta__title">View Locations</h3>
            <p className="beef-map-cta__text">
              See below for a map of participating partner locations
            </p>
          </div>
          <a
            className="beef-map-cta__arrow"
            href="#beef-map"
            onClick={scrollToMap}
            aria-label="Scroll to the locations map"
          >
            <img src={arrowDown} alt="" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}
